import { render, staticRenderFns } from "./preliminarySelection.vue?vue&type=template&id=8ba216d0&scoped=true&"
import script from "./preliminarySelection.vue?vue&type=script&lang=js&"
export * from "./preliminarySelection.vue?vue&type=script&lang=js&"
import style0 from "./preliminarySelection.vue?vue&type=style&index=0&id=8ba216d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba216d0",
  null
  
)

export default component.exports